import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import type { UploadApplication } from '@xing-com/crate-common-graphql-types';

import { UploadRequestVideoDocument } from '../graphql/mutations/upload-request-video-mutation.gql-types';

type Options = {
  application: UploadApplication;
  file: File;
};
export const useUploadRequest = (): ((options: Options) => Promise<string>) => {
  const { $t } = useIntl();
  const [uploadRequest] = useMutation(UploadRequestVideoDocument);

  return useCallback(
    async ({ application, file }: Options) => {
      const { data } = await uploadRequest({
        variables: {
          application: application,
          fileSize: file.size,
        },
      });
      const { id, url, authToken } = data?.uploadRequest?.success ?? {};

      if (!url || !authToken) {
        throw Error($t({ id: 'VIDEO_UPLOADING_ERROR' }));
      }

      const response = await fetch(url, {
        method: 'PATCH',
        headers: {
          Authorization: `Bearer ${authToken}`,
          'Upload-Offset': '0',
          'Tus-Resumable': '1.0.0',
          'Content-Type': 'application/offset+octet-stream',
        },
        body: file,
      });

      if (!response.ok) {
        throw Error($t({ id: 'VIDEO_UPLOADING_ERROR' }));
      }

      return id;
    },
    [$t, uploadRequest]
  );
};
